import * as React from 'react';
import { connect, Provider } from 'react-redux';
import {
  addReportToWorkZoneSearch,
  removeReportFromWorkZoneSearch,
  updateNdotWorkZoneIndicator,
  workZoneSearch
} from './redux-objects/actions';
import DataTable from '../DataTable';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import { Button } from 'react-bootstrap';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker } from 'react-dates';
import ReactDOM from 'react-dom';
import * as urls from '../shared/urls';
import { IWorkZoneSearchResult } from './business-objects/types';
import './assets/workZoneSpace.scss'
import moment from "moment";
import { QueueStartDate } from '../WorkflowQueues/common';
import ViewAllButton from '../DocumentViewer/ViewAllButton';
import Store from '../../store/Store';
import rootReducer from '../../store/Reducers';

const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');

const reduxStore = Store({}, rootReducer);

export interface IWorkZoneSearchActionProps {
  workZoneSearch?: (url: string) => void;
  updateNdotWorkZoneIndicator?: (url: string) => Promise<any>;
  removeReportFromWorkZoneSearch?: (url: string) => Promise<any>;
  addReportToWorkZoneSearch?: (url: string) => void;
}

interface IWorkZoneSearchStateProps {
  webServiceURL: string;
  searchResults: IWorkZoneSearchResult[];
}

interface IWorkZoneSearchProps extends IWorkZoneSearchActionProps, IWorkZoneSearchStateProps {
}

const initialState = {
  startDate: moment(QueueStartDate),
  endDate: moment(),
  focusedInput: null,
  crashKey: '',
  isGettingImage: false,
  workZoneChkbx: false,
  removedReportsChkbx: false,
  workZoneChkbxLogic: false,
  deletedSearchResults: false,
  searchResults: []
};
type WorkZoneSearchState = Readonly<typeof initialState>;

class WorkZoneSearch extends React.Component<IWorkZoneSearchProps, WorkZoneSearchState> {
  public constructor(props: IWorkZoneSearchProps) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    // this.doSearch().then();
    this.setState({ workZoneChkbx: this.state.workZoneChkbxLogic })
  }

  async doSearch() {
    let uri = this.props.webServiceURL + urls.WORK_ZONE_SEARCH;

    let params = {
      crashKey: this.state.crashKey,
      startDate: this.state.startDate.toDate().toUTCString(),
      endDate: this.state.endDate.toDate().toUTCString(),
      workZoneIndicatorChkbx: this.state.workZoneChkbx
    };

    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + '=' + esc(params[k]))
      .join('&');

    uri = uri + '?' + query;

    await this.props.workZoneSearch(uri);
  }

  handleViewDisapproveWorkZoneChkbx() {
    this.setState({ deletedSearchResults: true })
    this.setState({ workZoneChkbx: false })
    this.setState({ removedReportsChkbx: !this.state.removedReportsChkbx }, async () => await this.removedReportsFilter());
  }

  async removedReportsFilter() {
    if (this.state.removedReportsChkbx) {
      let uri = this.props.webServiceURL + urls.WORK_ZONE_REMOVED_REPORTS_SEARCH;

      let params = {
        crashKey: this.state.crashKey,
        startDate: this.state.startDate.toDate().toUTCString(),
        endDate: this.state.endDate.toDate().toUTCString(),
        workZoneIndicatorChkbx: this.state.workZoneChkbx
      };

      let esc = encodeURIComponent;
      let query = Object.keys(params)
        .map((k) => esc(k) + '=' + esc(params[k]))
        .join('&');

      uri = uri + '?' + query;
      return this.props.workZoneSearch(uri);
    } else {
      await this.handleSearchButton();
    }
  }

  async handleRemoveFromWorkZoneSearch(event: number, rowData: any) {
    await this.removeFromWorkZoneSearch(event, rowData);
    await this.doSearch()
  }

  async removeFromWorkZoneSearch(event: number, rowData: any) {
    let uri = this.props.webServiceURL + urls.REMOVE_REPORT_FROM_WORK_ZONE_SEARCH;
    let params = {
      reportId: rowData.id,
    };

    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + '=' + esc(params[k]))
      .join('&');

    uri = uri + '?' + query;

    await this.props.removeReportFromWorkZoneSearch(uri).then(() => this.doSearch());
  }

  async handleUpdateNdotWorkZoneIndicator(event: number, rowData: any) {
    await this.updateNdotWorkZoneIndicator(event, rowData);
    // await this.doSearch()
  }

  async handleDisapproveWorkZone(event: number, rowData: any) {
    let uri = this.props.webServiceURL + urls.NDOT_WORK_ZONE_DISAPPROVE;
    let params = {
      reportId: rowData.id
    };

    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + '=' + esc(params[k]))
      .join('&');

    uri = uri + '?' + query;

    await this.props.updateNdotWorkZoneIndicator(uri).then(() => {
      if (this.state.removedReportsChkbx) {
        this.removedReportsFilter();
      } else {
        this.doSearch();
      }
    });
  }


  async updateNdotWorkZoneIndicator(event: number, rowData: any) {
    let uri = this.props.webServiceURL + urls.NDOT_WORK_ZONE_INDICATOR_UPDATE;
    let params = {
      reportId: rowData.id,
      crashKey: rowData.crashKey,
      ndotWorkZoneIndicator: rowData.ndotWorkZoneIndicator
    };

    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + '=' + esc(params[k]))
      .join('&');

    uri = uri + '?' + query;
    let updateWorkZoneCall = this.props.updateNdotWorkZoneIndicator(uri)
    await updateWorkZoneCall.then(() => {
      this.doSearch();
    });
  }

  async handleSearchButton() {
    this.setState({ deletedSearchResults: false, removedReportsChkbx: false, workZoneChkbx: false }, () => {
      this.doSearch();
    });
  }

  async handleWorkZoneTrueFilter(e: React.FormEvent) {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    this.setState({ deletedSearchResults: false });
    this.setState({ removedReportsChkbx: false });
    this.setState({ workZoneChkbx: el.checked }, async () => {
      await this.doSearch();
    });
    this.setState({ workZoneChkbxLogic: !el.checked })
  }

  /*
  async getData() {
      if (this.state.workZoneChkbx == false) {
          return this.props.searchResults.filter((x) => x.workZoneIndicator != "True")
      } else {
          return this.props.searchResults
      }
  }
*/
  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      this.setState({ startDate, endDate }, async () => {
        await this.doSearch();
      });
    }
  }

  handleCrashKeyChange(e: React.FormEvent) {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    this.setState({ crashKey: el.value }, async () => {
      await this.doSearch();
    });
  }

  public render() {
    const columnDefs = [
      {
        targets: 0,
        width: '150px',
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div>
              <Provider store={reduxStore}>
                <ViewAllButton
                  reportId={rowData?.id}
                  dbToSearch='private'
                />
              </Provider>
              {rowData.ndotWorkZoneIndicator != "True" && !this.state.deletedSearchResults &&
                <Button
                  className='workZoneSearchButton'
                  variant='outline-primary'
                  size='sm'
                  data-id={cellData}
                  onClick={async () => await this.handleUpdateNdotWorkZoneIndicator(cellData, rowData)}
                >
                  Approve
                </Button>
              }
              {rowData.ndotWorkZoneIndicator == "True" &&
                <Button
                  className='workZoneSearchButton'
                  variant='outline-danger'
                  size='sm'
                  data-id={cellData}
                  onClick={async () => await this.handleUpdateNdotWorkZoneIndicator(cellData, rowData)}
                >
                  Undo Approval
                </Button>
              }
              {!this.state.deletedSearchResults && !this.state.workZoneChkbx &&
                <Button
                  className='removeFromWorkZoneSearch'
                  variant='outline-danger'
                  size='sm'
                  data-id={cellData}
                  onClick={async () => this.handleDisapproveWorkZone(cellData, rowData)}
                >
                  Disapprove
                </Button>
              }
              {rowData.ndotWorkZoneIndicator == "True" &&
                <Button
                  className='workZoneCompleteButton'
                  variant='outline-danger'
                  size='sm'
                  data-id={cellData}
                  onClick={async () => await this.handleRemoveFromWorkZoneSearch(cellData, rowData)}
                >
                  <a className='workZoneCompleteButtonText'>
                    Complete
                  </a>
                </Button>
              }
              {this.state.deletedSearchResults && !this.state.workZoneChkbx &&
                <Button
                  className='addToWorkZoneSearch'
                  variant='outline-danger'
                  size='sm'
                  data-id={cellData}
                  onClick={async () => await this.handleDisapproveWorkZone(cellData, rowData)}
                >
                  Undo Disapproval
                </Button>
              }
            </div>,
            td
          ),
      },
      {
        targets: 2, // crash date
        render: function (data) {
          return moment(data).format('MM/DD/YYYY'); // ('MMMM Do YYYY');
        },
        type: 'date',
      },
    ];

    const columns = [
      {
        title: 'Available Actions',
        data: 'id',
        class: 'actionBtns'
      },
      {
        title: 'County',
        data: 'county',
      },
      {
        title: 'Crash Date',
        data: 'crashDate',
        class: 'crashDate'
      },
      {
        title: 'Crash Key',
        data: 'crashKey',
        className: 'crashKey'
      },
      {
        title: 'Current Workflow Step',
        data: 'currentWorkflowStep',
        class: 'currentWorkflowStep'
      },
      {
        title: 'Work Zone Indicator',
        data: 'workZoneIndicator',
        class: 'workZoneIndicator'
      },
      {
        title: 'NDOT Work Zone Approved',
        data: 'ndotWorkZoneIndicator',
        class: 'ndotWorkZoneIndicator'
      }
    ];

    const options = {
      className: 'table table-striped table-bordered',
      select: false,
      dom: 'frtipB'
    };
    return (
      <div className='app'>
        <div className='row'>
          <div className='col-sm-6'>
            <h3>Work Zone Search</h3>
          </div>
        </div>
        <hr className='lineBreak' />
        <Form>
          <Form.Row>
            <Form.Group as={Col} controlId='workZoneSearchesStartDate'>
              <Form.Label>Crash Date</Form.Label>
              <br />
              <DateRangePicker
                startDate={this.state.startDate}
                startDateId='workZoneSearchesStartDate'
                endDate={this.state.endDate}
                endDateId='workZoneSearchesEndDate'
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                }
                focusedInput={this.state.focusedInput}
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                }
                isOutsideRange={() => false}
                small={true}
                block={false}
                minimumNights={0}
              />
            </Form.Group>
            <Form.Group as={Col} controlId='exampleForm.ControlSelect1'>
              <Form.Label>Crash Key</Form.Label>
              <Form.Control
                type='text'
                className='workZoneInput'
                value={this.state.crashKey}
                onChange={(e) => this.handleCrashKeyChange(e)}
              />
            </Form.Group>
            <div className='workZoneSpacing'> </div>
            <Form.Group>
              <div>
                <Form.Group controlId='workZoneCheckbox'>
                  <Form.Check
                    type='checkbox'
                    data-field='workZoneCheckbox'
                    label=' View NDOT Approved Work Zones'
                    checked={this.state.workZoneChkbx}
                    onChange={(e) => this.handleWorkZoneTrueFilter(e)}
                  />
                </Form.Group>
              </div>
              <div>
                <Form.Group controlId='disapprovedWorkZoneCheckbox' className='disapprovedWorkZoneCheckbox'>
                  <Form.Check
                    type='checkbox'
                    data-field='disapprovedWorkZoneCheckbox'
                    label=' View NDOT Disapproved Work Zones'
                    checked={this.state.removedReportsChkbx}
                    onChange={() => this.handleViewDisapproveWorkZoneChkbx()}
                  />
                </Form.Group>
              </div>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId='searchButton'>
              <Button
                variant='primary'
                onClick={() => this.handleSearchButton()}
              >
                Search
              </Button>
            </Form.Group>
          </Form.Row>
          <Form.Row />
        </Form>
        {this.props.searchResults && this.props.searchResults.length > 0 && (
          <DataTable
            id='tblWorkZoneSearches'
            data={this.props.searchResults}
            columns={columns}
            columnDefs={columnDefs}
            actionsColumn='first'
            select={false}
            {...options}
          />
        )}
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    searchResults: state.WorkZoneSearch.results,
  };
}

const mapDispatchToProps = {
  workZoneSearch,
  updateNdotWorkZoneIndicator,
  removeReportFromWorkZoneSearch,
  addReportToWorkZoneSearch
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkZoneSearch);
